import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const SocialProof = () => {
  const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    role: 'Marketing Consultant',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_128f7e26a-1763297659639.png",
    avatarAlt: 'Professional headshot of Caucasian woman with shoulder-length brown hair in business attire',
    quote: 'AuthorPreneur AI helped me publish my first book in just 6 weeks. The AI agents made the entire process seamless.',
    rating: 5
  },
  {
    id: 2,
    name: 'David Chen',
    role: 'Tech Entrepreneur',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1cb933d20-1763293416126.png",
    avatarAlt: 'Professional headshot of Asian man with short black hair wearing navy suit and glasses',
    quote: 'The market research and formatting tools saved me months of work. Now I have a published book that opens doors.',
    rating: 5
  },
  {
    id: 3,
    name: 'Maria Rodriguez',
    role: 'Business Coach',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1aace36c3-1763295955473.png",
    avatarAlt: 'Professional headshot of Hispanic woman with long dark hair in professional blazer',
    quote: 'This platform transformed my expertise into a published book. The community support is invaluable.',
    rating: 5
  }];


  const stats = [
  { value: '10,000+', label: 'Books Published' },
  { value: '4.9/5', label: 'Average Rating' },
  { value: '95%', label: 'Success Rate' }];


  return (
    <div className="space-y-6">
      <div className="grid grid-cols-3 gap-4">
        {stats?.map((stat, index) =>
        <div key={index} className="text-center p-4 bg-muted/50 rounded-lg border border-border">
            <div className="text-2xl font-heading font-bold text-primary mb-1">
              {stat?.value}
            </div>
            <div className="text-xs text-muted-foreground">
              {stat?.label}
            </div>
          </div>
        )}
      </div>
      <div className="space-y-4">
        <h4 className="text-sm font-heading font-semibold text-foreground">
          Trusted by Entrepreneurs Worldwide
        </h4>

        {testimonials?.map((testimonial) =>
        <div
          key={testimonial?.id}
          className="p-4 bg-card border border-border rounded-lg space-y-3">

            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                <Image
                src={testimonial?.avatar}
                alt={testimonial?.avatarAlt}
                className="w-full h-full object-cover" />

              </div>
              <div className="flex-1 min-w-0">
                <h5 className="text-sm font-medium text-foreground">
                  {testimonial?.name}
                </h5>
                <p className="text-xs text-muted-foreground">
                  {testimonial?.role}
                </p>
              </div>
              <div className="flex items-center space-x-1">
                {[...Array(testimonial?.rating)]?.map((_, i) =>
              <Icon key={i} name="Star" size={14} color="var(--color-accent)" />
              )}
              </div>
            </div>
            <p className="text-xs text-muted-foreground italic">
              "{testimonial?.quote}"
            </p>
          </div>
        )}
      </div>
      <div className="flex items-center justify-center space-x-6 pt-4 border-t border-border">
        <div className="flex items-center space-x-2">
          <Icon name="Shield" size={16} color="var(--color-success)" />
          <span className="text-xs text-muted-foreground">Stripe Secured</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Lock" size={16} color="var(--color-success)" />
          <span className="text-xs text-muted-foreground">SSL Certified</span>
        </div>
      </div>
    </div>);

};

export default SocialProof;